<template>
    <sys-register-base 
        :loading="saving" 
        @onSave="save" 
        :model.sync="model" 
        :title="title" 
        :icon="icon" 
        v-bind:show.sync="dialog"
        maxWidth="70%"
    >
        <template v-slot:form>
            
            <v-progress-linear
                v-if="loading"
                indeterminate
                color="yellow darken-2"
            />
            
            <v-tabs class="ma-0" v-model="tab">
                <v-tab key="main">Textos</v-tab>
                <v-tab key="show">Exibição</v-tab>
            </v-tabs>
            <v-tabs-items  v-model="tab">
                <v-tab-item key="main">
                    <v-container v-if="model">
                            <v-row v-if="acesso.instituicao.id == 1">
                                <v-col cols="12" sm="12">
                                    <v-alert
                                        dense
                                        border="left"
                                        type="warning"
                                    >
                                        As alterações realizadas serão consideradas <strong>PADRÃO</strong> para as <strong>DEMAIS INSTITUIÇÕES</strong>.
                                    </v-alert>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-text-field 
                                        v-model="model.title" 
                                        autofocus 
                                        :error="!!errors.title" 
                                        :error-messages="errors.title" 
                                        label="Título"
                                        clearable
                                        persistent-placeholder
                                        :placeholder="model.default.title"
                                    />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-textarea
                                        :error-messages="errors.header" 
                                        v-model="model.header" 
                                        label="Cabeçalho"
                                        outlined
                                        clearable
                                    />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-text-field 
                                        v-model="model.caption_availablity"     
                                        :error="!!errors.caption_availablity" 
                                        :error-messages="errors.caption_availablity" 
                                        clearable
                                        label="Cabeçalho do quadro Disponibilidade"
                                        persistent-placeholder
                                        :placeholder="model.default.caption_availablity"
                                    />
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field 
                                        v-model="model.caption_attributions" 
                                        :error="!!errors.caption_attributions" 
                                        :error-messages="errors.caption_attributions"
                                        clearable
                                        label="Cabeçalho do quadro Atribuições"
                                        persistent-placeholder
                                        :placeholder="model.default.caption_attributions"
                                    />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="4">
                                    <v-text-field 
                                        v-model="model.caption_class_time_tables"     
                                        :error="!!errors.caption_class_time_tables" 
                                        :error-messages="errors.caption_class_time_tables"
                                        clearable
                                        label="Cabeçalho do quadro Horário das Aulas"
                                        persistent-placeholder
                                        :placeholder="model.default.caption_class_time_tables"
                                    />
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-text-field 
                                        v-model="model.caption_activities" 
                                        :error="!!errors.caption_activities" 
                                        :error-messages="errors.caption_activities"
                                        clearable
                                        label="Cabeçalho Quadro Atividades Docentes"
                                        persistent-placeholder
                                        :placeholder="model.default.caption_activities"
                                    />
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-text-field 
                                        v-model="model.caption_activities_admin" 
                                        :error="!!errors.caption_activities_admin" 
                                        :error-messages="errors.caption_activities_admin"
                                        clearable
                                        label="Cabeçalho Quadro Atividades Administrativas"
                                        persistent-placeholder
                                        :placeholder="model.default.caption_activities_admin"
                                    />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="3">
                                    <v-text-field 
                                        v-model="model.caption_activity_time_tables"     
                                        :error="!!errors.caption_activity_time_tables" 
                                        :error-messages="errors.caption_activity_time_tables" 
                                        clearable
                                        label="Cabeçalho do quadro Horário das Atividades"
                                        persistent-placeholder
                                        :placeholder="model.default.caption_activity_time_tables"
                                    />
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-text-field 
                                        v-model="model.caption_summary" 
                                        :error="!!errors.caption_summary" 
                                        :error-messages="errors.caption_summary"
                                        clearable
                                        label="Cabeçalho do Quadro Resumo"
                                        persistent-placeholder
                                        :placeholder="model.default.caption_summary"
                                    />
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-text-field 
                                        v-model="model.caption_joins" 
                                        :error="!!errors.caption_joins" 
                                        :error-messages="errors.caption_joins"
                                        clearable
                                        label="Cabeçalho do Quadro de Junção"
                                        persistent-placeholder
                                        :placeholder="model.default.caption_joins"
                                    />
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-text-field 
                                        v-model="model.text_additional_signature" 
                                        :error="!!errors.text_additional_signature" 
                                        :error-messages="errors.text_additional_signature"
                                        clearable
                                        label="Responsável Assinatura Adicional"
                                        persistent-placeholder
                                        :placeholder="model.default.text_additional_signature"
                                    />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="10">
                                    <v-textarea
                                        v-model="model.text_work_load_reduction" 
                                        :error-messages="errors.text_work_load_reduction" 
                                        label="Texto Redução de Carga Horária"
                                        outlined
                                        clearable
                                        @selection-change="range = $event"
                                        id="editor"
                                        placeholder="Utilize as tags para configuração do texto"
                                    />
                                </v-col>
                                <v-col cols="12" sm="2">
                                    <v-select
                                        v-model="selectedTag"
                                        :items="tags"
                                        @change="setField($event)"
                                        return-object
                                        item-text="name"
                                        hide-details
                                        label="Tags"
                                    />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-textarea
                                        :error-messages="errors.footer" 
                                        v-model="model.footer" 
                                        label="Rodapé"
                                        outlined
                                        clearable
                                    />
                                </v-col>
                            </v-row>
                    </v-container>
                </v-tab-item>
                <v-tab-item key="show">
                    <v-container v-if="model" class="px-6 py-4">
                        <section v-for="(section, index) in showSections" :key="section.title" :class="{ 'mt-6': index > 0 }">
                            <div class="d-flex align-center">
                                <v-icon small color="primary" class="mr-2">{{ section.icon }}</v-icon>
                                <span class="text-subtitle-2 font-weight-bold text-uppercase primary--text">{{ section.title }}</span>
                            </div>
                            <div class="text-caption grey--text text--darken-1 mt-1">{{ section.description }}</div>
                            <v-divider class="mt-2 mb-3" />
                            <v-row dense>
                                <v-col v-for="item in section.items" :key="item.key" cols="12" sm="6" md="4" class="py-0">
                                    <s-switch dense inset :text-helper="item.help" v-model="model[item.key]" :label="item.label"/>
                                </v-col>
                            </v-row>
                        </section>
                    </v-container>
                </v-tab-item>

            </v-tabs-items>
            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>
        </template>
    </sys-register-base>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
    name: "SysTeacherExtractSetting",
    data: (vm) => ({
        dialog: false,
        error: false,
        errors: {},
        message: '',
        loading: false,
        selectedTag: null,
        saving: false,
        model: null,
        range: null,
        tab: 0,
        // Exibição: cada item mantém o mesmo campo (key), rótulo e ajuda de antes;
        // "show_ranges" (Exibir intervalos) segue desativado, como estava comentado.
        showSections: [
            {
                title: 'Quadros do extrato',
                icon: 'mdi-view-dashboard-outline',
                description: 'Escolha quais quadros aparecem no extrato.',
                items: [
                    { key: 'show_summary', label: 'Quadro Resumo', help: 'Exibir quadro resumo da Carga Horária' },
                    { key: 'show_availability', label: 'Disponibilidade', help: 'Exibir quadro de Disponibilidade' },
                    { key: 'show_attributions', label: 'Atribuição', help: 'Exibir quadro de Atribuição de aulas' },
                    { key: 'show_class_time_tables', label: 'Horário de Aulas', help: 'Exibir quadro de Horário de Aula' },
                    { key: 'show_activities', label: 'Atividades Docente', help: 'Exibir quadro de Atividades Docente' },
                    { key: 'show_activities_admin', label: 'Atividades Administrativas', help: 'Exibir quadro de Atividades Administrativa' },
                    { key: 'show_activity_time_tables', label: 'Horário das Atividades', help: 'Exibir quadro de Horário de Atividades' },
                    { key: 'show_activities_offered', label: 'Atividades Ofertadas', help: 'Exibir quadro de Atividades Ofertadas (soma da carga horária das ofertas em que o professor está vinculado)' },
                    { key: 'show_joins', label: 'Exibir Junções', help: 'Exibir as turmas da junção' },
                ],
            },
            {
                title: 'Cabeçalho do extrato',
                icon: 'mdi-card-account-details-outline',
                description: 'Informações da instituição e do professor exibidas no topo.',
                items: [
                    { key: 'show_company_logo', label: 'Logo da empresa', help: 'Exibir logo da empresa' },
                    { key: 'show_avatar', label: 'Foto do Professor', help: 'Exibir foto do professor' },
                    { key: 'show_cnpj', label: 'CNPJ', help: 'Exibir Cnpj no título do extrato' },
                    { key: 'show_position', label: 'Cargo', help: 'Exibir cargo do professor' },
                    { key: 'show_work_regime', label: 'Regime de Trabalho', help: 'Exibir Regime de Trabalho do professor' },
                    { key: 'show_titling', label: 'Titulação', help: 'Exibir titulação do professor' },
                ],
            },
            {
                title: 'Detalhes dos quadros',
                icon: 'mdi-tune',
                description: 'Ajustes de conteúdo dentro dos quadros.',
                items: [
                    { key: 'group_schedules', label: 'Agrupar Horários', help: 'Agrupar horários das aulas com início e fim' },
                    { key: 'show_discipline_type', label: 'Tipo Disciplina', help: 'Exibir tipo da disciplina no quadro de atribuições' },
                    { key: 'show_grid_dates', label: 'Data da Aula', help: 'Exibir datas das ofertas por data no quadro de horários' },
                    { key: 'show_info_joins', label: 'Exibir Info. Junções', help: 'Exibir as informações da junção' },
                    { key: 'show_only_work_load_pay', label: 'Exibir apenas CH Paga', help: 'Exibir apenas atribuições com tipo de carga horária paga' },
                ],
            },
            {
                title: 'Rodapé e assinaturas',
                icon: 'mdi-pen',
                description: 'Confirmações, assinaturas e informações finais do documento.',
                items: [
                    { key: 'show_workload_confirmation', label: 'Confirmação de CH', help: 'Exibir confirmação de carga horária' },
                    { key: 'show_work_load_reduction', label: 'Redução CH', help: 'Exibir texto quando houver redução de carga horária' },
                    { key: 'show_teacher_signature', label: 'Assinatura', help: 'Exibir campo de assinatura do professor' },
                    { key: 'show_additional_signature', label: 'Ass. Adicional', help: 'Exibir campo de assinatura adicional' },
                    { key: 'show_footer_city_date', label: 'Município', help: 'Exibir município da Instituição junto com a data no rodapé do documento' },
                ],
            },
        ],
        tags: [
            { id: 1, name: 'NOME' },
            { id: 2, name: 'CH_ATUAL' },
            { id: 3, name: 'CH_ANTERIOR' },
            { id: 4, name: 'CH_DIFERENCA' },
        ]
    }),
    created(){
       
       
    },

    computed: {
      ...mapState('auth', ['acesso']),
    },

    watch: {
        
        dialog(dialog_new, dialog_old) {
            
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        show(show_new, show_old) {
            
            this.dialog = show_new;
            
            if(show_new){
                this.tab = 0;
                this.error = false;
                this.errors = {};
                this.getData();
            }
        },
        
    },
    props: {
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-cog-box"
        },
        title: {
            type: String,
            default: "Configuração Extrato Professor"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        ...mapActions('teacher', ['ActionIndexTeacherExtractSetting', 'ActionUpdateTeacherExtractSetting']),

        getData(){

            this.error = false;
            this.message = '';
            this.loading = true;
            this.model = null;
            this.modelDefault = null;

            var payload = {
                find_columns: {
                    institution_id: this.acesso.instituicao.id,
                },
            };
            

            this.ActionIndexTeacherExtractSetting(payload)
                .then((res) => {
                    this.model = res.data.length > 0 ? res.data[0] : null;
                })
                .catch((error) =>{
                    
                })
                .finally(() => {
                     this.loading = false;
                })

        },

        setField(tag){


            const insert = '[[' + tag.name + ']]';

            if(this.model.text_work_load_reduction){
                this.model.text_work_load_reduction += insert;
            }else{
                this.model.text_work_load_reduction = insert;
            }

            
        //     const el = document.getElementById('editor');
        //     const textarea = el.querySelector('textarea')
            
        //    // posição inicial e final da seleção
        //     const start = textarea.selectionStart;
        //     const end = textarea.selectionEnd;

        //     // texto que quero inserir
        //     const insert = '[[' + tag.name + ']]';
        //     let text = this.model.text_work_load_reduction;

        //     // substitui o trecho selecionado pelo texto novo
        //     this.model.text_work_load_reduction = 
        //         text.substring(0, start) +
        //         insert +
        //         text.substring(end);

        //     // reposiciona o cursor depois do texto inserido
        //     this.nextTick(() => {
        //         textarea.selectionStart = textarea.selectionEnd = start + insert.length;
        //         el.focus();
        //     });

        },
        
        save(edit)
        {
            if(!this.model){
                return;
            }
            
            this.error = false;
            this.errors = [];
            this.message = '';
            this.saving = true;

            Object.assign(this.model, {institution_id: this.acesso.instituicao.id})

            if(edit) {
                this.ActionUpdateTeacherExtractSetting(this.model)
                .then((res) => {
                    this.model = res.data;
                })
                .catch((error) =>{
                    this.error      = true;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                     this.saving = false;
                     this.dialog = false;
                })
            } 
        },
    }
}
</script>